// extracted by mini-css-extract-plugin
module.exports = {"ConfettiContainer":"ConfettiDispencer_ConfettiContainer__31sVI"};